import * as PIXI from "pixi.js";
import Display from "./Display.js";
import Library   from "../utils/Library";
import { gsap } from "gsap";

export default class AnimatedSpriteResponsive extends PIXI.Container
{
    constructor (anims, responsive = {})
    {
        super();

        this.responsive = responsive;

        if (this.responsive.anchor)
            this.anchor = this.responsive.anchor;

        this.anims = anims;
        this.currentAnim = null;
        this.framePerSecond = 12;
        this.uuid = Math.random() * 1000 >> 0;

        this.buildAnimation();

    }

    // removeIn (delay)
    // {
    //     setTimeout(() => this.removeFromParent(), delay);
    // }

    removeFromParent ()
    {
        if (this.parent)
            this.parent.removeChild(this);
    }
    debugAnim (e)
    {




        if (strKey === "1")
        {
            this.start("idle-1-loop");

        }
        // else if (strKey === "2")
        // {
        //     this.start("idle-1-loop");
        //
        // }
        // else if (strKey === "3")
        // {
        //     this.start("idle-1-outro");
        //
        // }

        else if (strKey === "4")
        {
            this.start("bounce");

        }
        else if (strKey === "5")
        {
            this.start("calm");
        }
        else if (strKey === "6")
        {
            this.start("joy");
        }
        else if (strKey === "7")
        {
            this.start("fear");
        }
        else if (strKey === "8")
        {
            this.start("sadness");
        }
        else if (strKey === "9")
        {
            this.start("listen");
        }
        else if (strKey === "q")
        {
            this.start("question");
        }
        else if (strKey === "w")
        {
            this.start("surprise");
        }


        else if (strKey === "-")
        {
            this.fps--;

        }
        else if (strKey === "+")
        {
            this.fps++;

        }

    }
    buildAnimation ()
    {
        for (let i = 0; i < this.anims.length; i++)
        {
            let objAnim = this.anims[i];


            // let animation = this.getAnimation({type: "animation", key: objAnim.atlas, animation: objAnim.key});
            //
            //
            // if (!animation)
            //     return;

            let sheet = Library.instance.getTexture(objAnim.atlas);

            let sprite = PIXI.AnimatedSprite.fromFrames(sheet.data.animations[objAnim.key]);

            if (this.responsive.anchor)
                sprite.anchor = this.responsive.anchor;


            objAnim.sprite = sprite;


        }



    }


    get fps ()
    {
        return this.framePerSecond;
    }

    set fps (iFps)
    {
        this.framePerSecond = iFps;

        if (this.currentAnim)
        {
            this.currentAnim.sprite.animationSpeed = this.framePerSecond / 60;
        }


    }

    start (strAnim, playOnSame = false, lastSprite = null, autoplay = true)
    {
        let strType = "loop";
        let source = strAnim;


        if (typeof strAnim === "object")
        {
            strType = strAnim.type;
            strAnim= strAnim.animation;
        }

        if (strType === "sequence")
        {
            let seq = source.animation;
            strAnim = strAnim.shift();
            source.animation.push(strAnim);
        }

        if (this.currentAnim)
        {

            if (this.currentAnim.anim === strAnim)
            {
                if (playOnSame)
                {
                    this.currentAnim.sprite.gotoAndPlay(0);
                }

                return;
            }

            if (lastSprite)
            {

                lastSprite.onComplete = null;
            }
            this.currentAnim.sprite.onComplete = null;
            this.removeChild(this.currentAnim.sprite);
        }

        let objAnim = this.anims.find( (a) => a.anim === strAnim);

        if (objAnim)
        {
            if (!objAnim.sprite.debug)
            {
                objAnim.sprite.debug = strAnim + (Math.random() * 1000 >> 0);
            }
            this.currentAnim = objAnim;
            this.currentAnim.sprite.animationSpeed = this.framePerSecond / 60;
            this.addChild(this.currentAnim.sprite);

            this.currentAnim.sprite.loop = strType === "loop";


            if(autoplay)
            {
                this.currentAnim.sprite.gotoAndPlay(0);
            }
            else
            {
                this.currentAnim.sprite.gotoAndPlay(0);
            }
            this.currentAnim.sprite.onComplete = null;
            objAnim.sprite.debug = strAnim + (Math.random() * 1000 >> 0);



            if (strType === "sequence")
            {
                this.currentAnim.sprite.onComplete = () => this.start(source, true, this.currentAnim.sprite);
            }

        }

    }

    playFrameAt(frame)
    {
        this.currentAnim.sprite.gotoAndPlay(frame);
    }

    stopFrameAt(frame)
    {
        this.currentAnim.sprite.gotoAndStop(frame);
    }


    startSequence (arrAnim)
    {

    }
    getAnimation (element)
    {
        let strType = element.type;
        if (strType === "animation")
        {
            let texture =  Library.instance.getTexture(element.key);

            let anim = texture.animations[element.animation];

            return anim;
        }

        return null;
    }

    setResponsive (responsive)
    {
        this.responsive = responsive;

        if (this.responsive.anchor)
            this.anchor = this.responsive.anchor;
    }
    onUpdateResponsiveScale ()
    {
        if (this.responsive.scale)
        {
            this.responsive.scale.x = this.scale.x;
            this.responsive.scale.y = this.scale.y;
        }
    }

    bounce (dir, size, numberOfLoop = 1, callback)
    {
        this.start("bounce");

        size = dir === "right" ? size : -size;

        this.currentAnim.sprite.scale.x = dir === "right" ? -1 : 1;


        let playFrame = this.currentAnim.sprite.totalFrames * numberOfLoop;
        let duration = playFrame / this.framePerSecond;

        let goal = this.responsive.params.x.gravity + size;
        gsap.to(this.responsive.params.x,
                {
                    duration,
                    gravity:  goal,
                    //ease: "power1.inOut",
                    onUpdate: () => this.onUpdateLayout(),
                    onComplete: () => this.onBounceComplete(callback)
                });
    }

    onBounceComplete (callback)
    {
        this.start("idle-1-loop")
        this.currentAnim.sprite.scale.x = 1;

        if (callback)
            callback();
    }
    onUpdateLayout ()
    {
        const {width,height} = Display.getScreenSize();

        this.layout(width,height)
    }
    enableDrag ()
    {
        this.fctStartDrag = (e) => this.startDrag(e);
        this.fctDrag = (e) => this.onDrag(e);
        this.fctStopDrag = (e) => this.onStopDrag(e);

        this.fctKey = (e) => this.onKey(e);

        this.on("pointerdown", this.fctStartDrag)


        this.buttonMode = true;
        this.interactive = true;
    }

    startDrag (e)
    {


        document.addEventListener("pointermove", this.fctDrag );
        document.addEventListener("pointerup", this.fctStopDrag);
        document.addEventListener('keydown', this.fctKey);

        this.offset = {x: this.x - e.data.global.x, y: this.y - e.data.global.y};

        this.gfxAnchor = new PIXI.Graphics();
        this.gfxAnchor.beginFill(0x009900, 1);
        this.gfxAnchor.drawCircle(0,0, 20);
        this.gfxAnchor.endFill();

        this.addChild(this.gfxAnchor);

    }

    onDrag (e)
    {

        //this.x = e.data.global.x + this.offset.x;
        this.x = e.clientX + this.offset.x;
        //this.y = e.data.global.y + this.offset.y;
        this.y = e.clientY + this.offset.y;


    }



    onKey (e)
    {
        let strKey = e.key;

        if (strKey === "ArrowLeft")
        {
            if (this.responsive.anchor)
            {
                this.responsive.anchor.x -= 0.1;
                this.anchor = this.responsive.anchor;

            }
        }
        else if (strKey === "ArrowRight")
        {
            if (this.responsive.anchor)
            {
                this.responsive.anchor.x += 0.1;
                this.anchor = this.responsive.anchor;
            }
        }
        else if (strKey === "ArrowUp")
        {
            if (this.responsive.anchor)
            {
                this.responsive.anchor.y -= 0.1;
                this.anchor = this.responsive.anchor;

            }
        }
        else if (strKey === "ArrowDown")
        {
            if (this.responsive.anchor)
            {
                this.responsive.anchor.y += 0.1;
                this.anchor = this.responsive.anchor;

            }
        }
    }


    onStopDrag (e)
    {

        document.removeEventListener("mousemove", this.fctDrag );
        document.removeEventListener("pointermove", this.fctStopDrag);
        document.removeEventListener('keydown', this.fctKey);

        let width = Display.instance.getWidth();
        let height = Display.instance.getHeight();

        let newX = this.x / width;
        let newY = this.y / height;


        this.responsive.params.x.gravity = newX;
        this.responsive.params.y.gravity = newY;

        this.removeChild(this.gfxAnchor);
    }

    layout (width, height)
    {
        let size = {width, height};


        if (this.responsive.scale)
        {
            let ratio = this.getScaleRelativeRatio(width, height);

            super.scale.x = this.responsive.scale.x * ratio.x;
            super.scale.y = this.responsive.scale.y * ratio.y;
        }

        if (this.responsive.screen)
        {
            let strBasedOn = this.responsive.screen.scale;

            if (strBasedOn === "width")
            {
                this.width = width;
                this.scale.y = this.scale.x;
            }
            else if (strBasedOn === "height")
            {
                this.height = height;
                this.scale.x = this.scale.y;
            }
            else if (strBasedOn === "fillscreen")
            {
                let originalSize = this._texture.orig;

                let originalRatio = originalSize.width / originalSize.height;
                let currentRatio = width / height;

                //if currentRatio is larger than originalRatio, means that we must fill using width
                if (currentRatio > originalRatio)
                {
                    this.width = width;
                    this.scale.y = this.scale.x;
                }
                //if currentRatio is smaller than originalRatio, means that we must fill using height
                else
                {
                    this.height = height;
                    this.scale.x = this.scale.y;
                }


            }
        }

        for (let strKey in this.responsive.params)
        {
            let param = this.responsive.params[strKey];
            let gravity = param.gravity;
            let using = size[param.using];

            this[strKey] = gravity * using;


        }


    }

    getScaleRelativeRatio (width, height)
    {
        width = width || window.innerWidth;
        height = height || window.innerHeight;

        let size = {width, height};

        let iRatioX = 1;
        let iRatioY = 1;

        if (this.responsive.scale.relative)
        {
            if (this.responsive.scale.relative.x)
            {
                let relativeTo = this.responsive.scale.relative.x.to;
                let iBaseValue = this.responsive.scale.relative.x.baseValue;

                iRatioX = size[relativeTo] / iBaseValue;
            }

            if (this.responsive.scale.relative.y)
            {
                let relativeTo = this.responsive.scale.relative.y.to;
                let iBaseValue = this.responsive.scale.relative.y.baseValue;

                iRatioY = size[relativeTo] / iBaseValue;
            }
        }

        return {x: iRatioX, y:iRatioY};

    }

    startAnimationMovement (type, param)
    {
        this.animationType = type;

        if (this.animationType === "papillon")
        {
            let baseSpeed = 0.00025 + Math.random() * 0.00025;

            let screen = Math.floor(this.responsive.params.x.gravity);
            this.limitMinX = screen + 0.01;
            this.limitMaxX = screen + 0.99;

            this.limitMinY = 0.02;
            this.limitMaxY = param;

            let speed = (baseSpeed /  0.0005) * 10;
            this.fps = 6 + speed;

            this.papillonSpeed = baseSpeed;
            this.papillonAngle = Math.PI / 180 * (Math.random() * 360);
            this.lastTime = new Date().getTime();
            this.currentStep = Math.random() * 200 >> 0;
            this.changeStep = 0;
            this.changeAngle = 45;
            this.maxStep = 200;


            let colors = [0xFF0000, 0xFFA500, 0x0000FF, 0x800080, 0xFF1493];
            let color = colors[Math.random() * (colors.length - 0.01) >> 0];
            this.currentAnim.sprite.tint = color;

            this.startPapillon();
        }
        else if (this.animationType === "chauve-souris")
        {
            let baseSpeed = 0.0025 + Math.random() * 0.0025;

            let screen = Math.floor(this.responsive.params.x.gravity);
            this.limitMinX = screen + 0.01;
            this.limitMaxX = screen + 0.99;

            this.limitMinY = 0.02;
            this.limitMaxY = param;
            this.maxStep = 75;
            this.changeAngle = 135;

            let speed = (baseSpeed /  0.02) * 10;
            this.fps = 36 + speed;

            this.papillonSpeed = baseSpeed;
            this.papillonAngle = Math.PI / 180 * (Math.random() * 360);
            this.lastTime = new Date().getTime();
            this.currentStep = Math.random() * 200 >> 0;
            this.changeStep = 0;


            let colors = [0xFF0000, 0xFFA500, 0x0000FF, 0x800080, 0xFF1493];
            let color = colors[Math.random() * (colors.length - 0.01) >> 0];
            //this.currentAnim.sprite.tint = color;

            this.startPapillon();
        }
    }

    startPapillon ()
    {

        this.doPapillon();
    }

    doPapillon ()
    {
        requestAnimationFrame(() => this.doPapillon());

        let dirX = Math.cos(this.papillonAngle);
        let dirY = Math.sin(this.papillonAngle);

        let vecX = dirX * this.papillonSpeed;
        let vecY = dirY * this.papillonSpeed;

        let newTime = new Date().getTime();
        let elapsed = newTime - this.lastTime;

        let sin = Math.sin(elapsed * 0.005) * this.papillonSpeed * 3;
        this.lastTime = newTime;

        vecY += sin;

        if (vecX < 0 /*&& this.currentAnim.sprite.scale.x > 0*/)
        {
            this.currentAnim.sprite.scale.x = -1;
        }
        else
        {
            this.currentAnim.sprite.scale.x = 1;
        }

        this.responsive.params.x.gravity += vecX;
        this.responsive.params.y.gravity += vecY;

        this.currentStep++;

        if (this.changeStep > 0)
        {
            this.changeStep--;
        }


        if (this.currentStep > this.maxStep && Math.random() > 0.5)
        {
            this.papillonAngle += ((Math.PI / 180) * (Math.random() * this.changeAngle));
            this.currentStep = 0;
        }
        //
        //
        if (this.responsive.params.x.gravity < this.limitMinX)
        {
            this.currentStep = (this.maxStep / 2) >> 0;
            this.papillonAngle =  this.findCenterAngle(this.responsive.params.x.gravity, this.responsive.params.y.gravity);

        }
        else if (this.responsive.params.x.gravity > this.limitMaxX)
        {
            this.currentStep = (this.maxStep / 2) >> 0;
            this.papillonAngle =  this.findCenterAngle(this.responsive.params.x.gravity, this.responsive.params.y.gravity);
        }
        //
        //
        if (this.changeStep <= 0 && this.responsive.params.y.gravity < this.limitMinY)
        {
            this.currentStep = (this.maxStep / 2) >> 0;
            this.changeStep = this.maxStep;
            this.papillonAngle =  this.findCenterAngle(this.responsive.params.x.gravity, this.responsive.params.y.gravity);
        }
        else if (this.changeStep <= 0 && this.responsive.params.y.gravity > this.limitMaxY)
        {
            this.currentStep = (this.maxStep / 2) >> 0;
            this.changeStep = this.maxStep;
            this.papillonAngle =  this.findCenterAngle(this.responsive.params.x.gravity, this.responsive.params.y.gravity);
        }


        let {width, height} = Display.getCanvasSize();
        this.layout(width, height);
    }

    findCenterAngle (gravityX, gravityY)
    {
        let goalX = (Math.floor(gravityX) + (this.limitMaxY / 2)) * window.innerWidth;
        let goalY =  0.5 * window.innerHeight;


        let startX = gravityX * window.innerWidth;
        let startY = gravityY * window.innerHeight;

        let dx = goalX - startX;
        let dy = goalY - startY;

        let rad90 = Math.PI / 180 * 90;
        let angle = Math.atan2(dy, dx);

        return angle;
    }
    findAngle (goalX, goalY, currentX, currentY)
    {
        let x = currentX ?? this.responsive.params.x.gravity;
        let y = currentY ?? this.responsive.params.y.gravity;

        //find angle to center (0.5, 0.5)
        let dx = goalX - x;
        let dy = goalY - y;

        let rad90 = Math.PI / 180 * 90;
        let angle = Math.atan2(dy, dx);

        let deg = (180 / Math.PI )* angle;

        return angle;



    }

    fadeIn (duration = 1, delay = 0)
    {
        gsap.to(this, {alpha: 1, delay,duration });
    }
}
